Greenmile.MassiveSmartGeocode = Greenmile.MassiveSmartGeocode || {};

Greenmile.MassiveSmartGeocode.AcceptSelected = (function () {

    AcceptSelected.prototype = new Monet.Grid.ActionsModules.ButtonEventCheckBox();

    function AcceptSelected () {

        this.setValueBtn = function () {
            this.valueBtn = Monet.I18n.getResourcesByKey("SmartGeocode.grid.acceptSelected");
        };

        this.actionAfterClickButton = function () {

            try {

                const view = App.Views.MassiveSmartGeocode;
                const grid = App.Forms.MassiveSmartGeocode.table;
                const rowsSelected = grid.getSelectedRows();

                if (rowsSelected.length > 0) {
                    const confirmAcceptSelected = () => {
                        view.showLoadingAndDisableButtons();

                        const successCallback = () => {
                            view.hideLoadingAndEnableButtons() && App.Views.MassiveSmartGeocode.showGrid();
                        };

                        const errorCallback = () => {
                            view.hideLoadingAndEnableButtons();
                        };

                        const router = new App.Routers.MassiveSmartGeocode();
                        router.acceptSelected(rowsSelected, successCallback, errorCallback);
                    };

                    new Greenmile.Components.AlertModal("SmartGeocode.grid.confirmAcceptSelected",
                        null,
                        confirmAcceptSelected)
                    .show();

                } else {
                    new Greenmile.Components.AlertModal("Greenmile.actionGridButton.noItemChecked")
                        .show();
                }

            } catch (e) {

                const error = new Monet.Exception.ReturnError(this, "Error on action after click button on accept selected.", e);
                error.console();

            }

        };

        this.initialize = function (entity) {
            this.setEntity(entity);
            this.setSelector("#SmartGeocode .gridActions .grid_header__rigth");
            this.setScreenName("#SmartGeocode");
            this.setValueBtn();
            this.setId("btnAcceptSelected");
            this.setClassName("btn-secondary");
            this.setBtnSelector('#SmartGeocode #btnAcceptSelected');
            this.init();
        };

    }

    return AcceptSelected;

})();